import { render, staticRenderFns } from "./meetDClient.vue?vue&type=template&id=634302e4&scoped=true&"
import script from "./meetDClient.vue?vue&type=script&lang=js&"
export * from "./meetDClient.vue?vue&type=script&lang=js&"
import style0 from "./meetDClient.vue?vue&type=style&index=0&id=634302e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634302e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634302e4')) {
      api.createRecord('634302e4', component.options)
    } else {
      api.reload('634302e4', component.options)
    }
    module.hot.accept("./meetDClient.vue?vue&type=template&id=634302e4&scoped=true&", function () {
      api.rerender('634302e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/prekickoff/meetDClient.vue"
export default component.exports